import { c as create_ssr_component, a as subscribe, f as createEventDispatcher, o as onDestroy, b as add_attribute, e as escape, d as each, v as validate_component } from "./ssr.js";
import { c as classNames, f as formatDate } from "./util.js";
import { p as page } from "./stores.js";
import { P as PlainText } from "./PlainText.js";
import { R as RichText } from "./RichText.js";
import { N as NotEditable } from "./NotEditable.js";
const void_element_names = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function is_void(name) {
  return void_element_names.test(name) || name.toLowerCase() === "!doctype";
}
const CopyableRecipient = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let timeout;
  let { recipient } = $$props;
  let { slug } = $$props;
  let { editable } = $$props;
  createEventDispatcher();
  onDestroy(() => clearTimeout(timeout));
  if ($$props.recipient === void 0 && $$bindings.recipient && recipient !== void 0)
    $$bindings.recipient(recipient);
  if ($$props.slug === void 0 && $$bindings.slug && slug !== void 0)
    $$bindings.slug(slug);
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  $page.data.origin;
  $$unsubscribe_page();
  return `<div class="relative rounded-full px-3 py-0.5 mr-1 mb-1 text-sm sm:text-base inline-flex items-center space-x-1 border border-black"> ${recipient.has_seen ? `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>` : ``} <span${add_attribute("title", recipient.name ? recipient.email : "", 0)}>${escape(recipient.name || recipient.email)}</span> ${editable ? `<button data-svelte-h="svelte-5hxvr4"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg></button>` : ` <button data-svelte-h="svelte-37m4fj"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"></path></svg></button>`} ${``}</div>`;
});
const RecipientsSelector = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { recipients = [] } = $$props;
  let { is_public } = $$props;
  let { editable } = $$props;
  let { slug = void 0 } = $$props;
  let value;
  let result = [];
  let selectedResult = 0;
  let input;
  let resultsEl;
  if ($$props.recipients === void 0 && $$bindings.recipients && recipients !== void 0)
    $$bindings.recipients(recipients);
  if ($$props.is_public === void 0 && $$bindings.is_public && is_public !== void 0)
    $$bindings.is_public(is_public);
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  if ($$props.slug === void 0 && $$bindings.slug && slug !== void 0)
    $$bindings.slug(slug);
  return `<div class="max-w-screen-md mx-auto px-6 pb-8 relative"> ${editable || is_public || !is_public ? `${((tag) => {
    return tag ? `<${editable ? "button" : "div"}${add_attribute(
      "class",
      classNames("relative rounded-full px-3 py-0.5 mr-1 mb-1 text-sm sm:text-base inline-flex items-center space-x-1 bg-black text-white", ""),
      // pop to the top while editing visibility
      0
    )}>${is_void(tag) ? "" : `<span>${escape(is_public ? "Public" : "Private")}</span> ${editable ? `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 inline-block"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"></path></svg>` : ``}`}${is_void(tag) ? "" : `</${tag}>`}` : "";
  })(editable ? "button" : "div")}` : ``} ${``} ${each(recipients, (recipient, i) => {
    return `${validate_component(CopyableRecipient, "CopyableRecipient").$$render($$result, { recipient, editable, slug }, {}, {})}`;
  })} ${editable ? `<div class="relative border-gray-100 flex space-x-4 items-center py-2"><input autocomplete="off" id="search" name="search" class="block w-full border-none bg-transparent px-0 py-2 placeholder-gray-300 focus:border-black focus:text-gray-900 focus:placeholder-gray-400 focus:outline-none focus:ring-0" placeholder="Enter email or name to send to friends." type="text"${add_attribute("this", input, 0)}${add_attribute("value", value, 0)}></div> <div class="overflow-y-auto"${add_attribute("this", resultsEl, 0)}>${each(result, (friend, i) => {
    return `<button${add_attribute("class", classNames("w-full text-left block px-4 sm:px-6 py-3 border-b border-gray-100 text-gray-600 hover:text-black", selectedResult === i ? "bg-gray-100" : ""), 0)}>${friend.name ? `${escape(friend.name)} (${escape(friend.email)})` : `${escape(friend.email)}`} </button>`;
  })}</div>` : ``}</div>`;
});
const Post = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { title } = $$props;
  let { content } = $$props;
  let { created_at } = $$props;
  let { editable } = $$props;
  let titleEl;
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.content === void 0 && $$bindings.content && content !== void 0)
    $$bindings.content(content);
  if ($$props.created_at === void 0 && $$bindings.created_at && created_at !== void 0)
    $$bindings.created_at(created_at);
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div><div class="max-w-screen-md mx-auto px-6">${validate_component(NotEditable, "NotEditable").$$render($$result, { editable }, {}, {
      default: () => {
        return `<div class="pb-2 sm:text-lg">${escape(formatDate(created_at))}</div>`;
      }
    })} <h1 class="text-3xl md:text-5xl font-bold"${add_attribute("this", titleEl, 0)}>${validate_component(PlainText, "PlainText").$$render(
      $$result,
      {
        editable,
        placeholder: "Post title…",
        content: title
      },
      {
        content: ($$value) => {
          title = $$value;
          $$settled = false;
        }
      },
      {}
    )}</h1></div></div> <div class="max-w-screen-md mx-auto px-6"><div id="post_content" class="prose sm:prose-xl text-inherit">${validate_component(RichText, "RichText").$$render(
      $$result,
      {
        multiLine: true,
        editable,
        placeholder: "Post content…",
        content
      },
      {
        content: ($$value) => {
          content = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Post as P,
  RecipientsSelector as R
};
